import React, { Suspense } from "react";

export default function AppSuspense(props) {
  return <Suspense fallback={<div />} {...props} />;
}
